export default "/build/images/aero-score-d.36ffc0f7.png";